module.exports = __webpack_public_path__ + "static/media/authentication.5911f723.svg";